function dateToUTC(date) {
    const dateIntoUTC = new Date(date);

    const year = dateIntoUTC.getUTCFullYear();
    const month = String(dateIntoUTC.getUTCMonth() + 1).padStart(2, '0');
    const day = String(dateIntoUTC.getUTCDate()).padStart(2, '0');
    const hours = String(dateIntoUTC.getUTCHours()).padStart(2, '0');
    const minutes = String(dateIntoUTC.getUTCMinutes()).padStart(2, '0');
    const seconds = String(dateIntoUTC.getUTCSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}

if (window.matchMedia("(min-width: 750px)").matches) {
    // Desktop
    if (document.getElementById('counter')) {
        const deadlineText = document.getElementById('counter').getAttribute('data-offer-ends');
        const dateIntoUTC = dateToUTC(deadlineText);
        const dateParts = deadlineText.split(' ');
        const date = dateParts[0];
        const time = dateParts[1];

        const dateSegments = date.split('-');
        const dateObj = new Date(dateSegments[2], dateSegments[1] - 1, dateSegments[0]);

        const timeSegments = time.split(':');
        const timeObj = new Date(0, 0, 0, timeSegments[0], timeSegments[1], timeSegments[2]);

        const deadline = new Date(
            dateObj.getFullYear(),
            dateObj.getMonth(),
            dateObj.getDate(),
            timeObj.getHours(),
            timeObj.getMinutes(),
            timeObj.getSeconds()
        );

        function updateCounter() {
            const now = new Date();

            let difference = deadline - now;

            const days = Math.floor(difference / (1000 * 60 * 60 * 24))
                .toString()
                .padStart(2, '0');
            const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                .toString()
                .padStart(2, '0');
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
                .toString()
                .padStart(2, '0');
            const seconds = Math.floor((difference % (1000 * 60)) / 1000)
                .toString()
                .padStart(2, '0');

            document.getElementById('counter').querySelector('.days').innerHTML = days;

            document.getElementById('counter').querySelector('.hours').innerHTML = hours;

            document.getElementById('counter').querySelector('.min').innerHTML = minutes;

            document.getElementById('counter').querySelector('.sec').innerHTML = seconds;
            const banner = document.getElementById('block-counter__product-container');
            if (difference < 0) {
                clearInterval(interval);
                document.getElementById('counter').querySelector('.days').innerHTML = '00';

                document.getElementById('counter').querySelector('.hours').innerHTML = '00';

                document.getElementById('counter').querySelector('.min').innerHTML = '00';

                document.getElementById('counter').querySelector('.sec').innerHTML = '00';

                banner.classList.add('hidden');
            } else {
                banner.classList.remove('hidden');
            }
        }

        let interval = setInterval(updateCounter, 1000);
    }
}


const deadlineTextMobile = document.getElementById('counter-mobile').getAttribute('data-offer-ends');

if (deadlineTextMobile) {
    if (window.matchMedia('(max-width: 749px)').matches) {
        // Mobile
        const deadlineTextMobile = document.getElementById('counter-mobile').getAttribute('data-offer-ends');
        const dateIntoUTCMobile = dateToUTC(deadlineTextMobile);

        const datePartsMobile = deadlineTextMobile.split(' ');
        const dateMobile = datePartsMobile[0];
        const timeMobile = datePartsMobile[1];

        const dateSegmentsMobile = dateMobile.split('-');
        const dateObjMobile = new Date(dateSegmentsMobile[2], dateSegmentsMobile[1] - 1, dateSegmentsMobile[0]);

        console.log('Date object:', dateObjMobile);

        const timeSegmentsMobile = timeMobile.split(':');
        const timeObjMobile = new Date(
            0,
            0,
            0,
            timeSegmentsMobile[0],
            timeSegmentsMobile[1],
            timeSegmentsMobile[2]
        );

        const deadlineMobile = new Date(
            dateObjMobile.getFullYear(),
            dateObjMobile.getMonth(),
            dateObjMobile.getDate(),
            timeObjMobile.getHours(),
            timeObjMobile.getMinutes(),
            timeObjMobile.getSeconds()
        );

        function updateCounterMobile() {
            const now = new Date().getTime();

            let differenceMobile = deadlineMobile - now;

            const days = Math.floor(differenceMobile / (1000 * 60 * 60 * 24))
                .toString()
                .padStart(2, '0');
            const hours = Math.floor((differenceMobile % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                .toString()
                .padStart(2, '0');
            const minutes = Math.floor((differenceMobile % (1000 * 60 * 60)) / (1000 * 60))
                .toString()
                .padStart(2, '0');
            const seconds = Math.floor((differenceMobile % (1000 * 60)) / 1000)
                .toString()
                .padStart(2, '0');

            document.getElementById('counter-mobile').querySelector('.days').innerHTML = days;

            document.getElementById('counter-mobile').querySelector('.hours').innerHTML = hours;

            document.getElementById('counter-mobile').querySelector('.min').innerHTML = minutes;

            document.getElementById('counter-mobile').querySelector('.sec').innerHTML = seconds;
            const bannerMobile = document.getElementById('block-counter__product-container-mobile');
            if (differenceMobile < 0) {
                clearInterval(intervalMobile);
                document.getElementById('counter-mobile').querySelector('.days').innerHTML = '00';

                document.getElementById('counter-mobile').querySelector('.hours').innerHTML = '00';

                document.getElementById('counter-mobile').querySelector('.min').innerHTML = '00';

                document.getElementById('counter-mobile').querySelector('.sec').innerHTML = '00';

                bannerMobile.classList.add('hidden')
            } else {
                bannerMobile.classList.remove('hidden')
            }
        }

        let intervalMobile = setInterval(updateCounterMobile, 1000);
    }
} else {
    const bannerMobile = document.getElementById('block-counter__product-container-mobile');
    bannerMobile.classList.add('hidden')
}